<template>
  <div id="app">
    <notifications group="foo" />
    <router-view/>
    <div class="loading-mask" v-show="$store.getters.loading"></div>
  </div>
</template>
<script>
  export default {
    methods: {
      valToken() {
        let iduser = 0
        let url = window.location.href
        let separador = url.split('/')
        separador.forEach((item) => {
          if (item.includes('iduser')) {
            let id = item
            iduser = id.split('=')
          }
        })
        return iduser[1]
      },
      urlClean() {
        let urlFinal = ''
        let url = window.location.href
        let separador = url.split('/')
        let array = []
        
        separador.forEach((item) => {
          if (item.includes('iduser')) {
          } else {
            array.push(item)
          }
        })

        let urlfinal = array.join('/')

        return urlfinal
      }
    },
    mounted(){
        this.$store.commit('auth/setContacto', null)
        this.valToken()
        if (this.valToken() && this.valToken() > 0) {
          let objToken = {
            id: this.valToken(),
            url: process.env.VUE_APP_API_URL_AGENTE,
            company: process.env.VUE_APP_COMPANY_AGENTE
          }
          this.$store.dispatch('validatetoken/validateToken',  objToken)
          .then((resp) => {
            if (resp.ok) {
              window.location.href = this.urlClean()
            }
          }).catch((error) => {
            console.log('error: ', error.message)
            this.$router.push({ name: 'loginag', query: { url: this.urlClean() } })
          })
        }
    }
  }
</script>
